import ListDefinitionRejectionDialog from './ListDefinitionRejectionDialog';

export default ListDefinitionRejectionDialog;
